export default "__VITE_ASSET__C02O_S6f__"